/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateMeetingRequestStrategy } from './UpdateMeetingRequestStrategy';
import {
    UpdateMeetingRequestStrategyFromJSON,
    UpdateMeetingRequestStrategyFromJSONTyped,
    UpdateMeetingRequestStrategyToJSON,
    UpdateMeetingRequestStrategyToJSONTyped,
} from './UpdateMeetingRequestStrategy';

/**
 * 
 * @export
 * @interface UpdateMeetingRequest
 */
export interface UpdateMeetingRequest {
    /**
     * 
     * @type {UpdateMeetingRequestStrategy}
     * @memberof UpdateMeetingRequest
     */
    strategy: UpdateMeetingRequestStrategy;
}

/**
 * Check if a given object implements the UpdateMeetingRequest interface.
 */
export function instanceOfUpdateMeetingRequest(value: object): value is UpdateMeetingRequest {
    if (!('strategy' in value) || value['strategy'] === undefined) return false;
    return true;
}

export function UpdateMeetingRequestFromJSON(json: any): UpdateMeetingRequest {
    return UpdateMeetingRequestFromJSONTyped(json, false);
}

export function UpdateMeetingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateMeetingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'strategy': UpdateMeetingRequestStrategyFromJSON(json['strategy']),
    };
}

export function UpdateMeetingRequestToJSON(json: any): UpdateMeetingRequest {
    return UpdateMeetingRequestToJSONTyped(json, false);
}

export function UpdateMeetingRequestToJSONTyped(value?: UpdateMeetingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'strategy': UpdateMeetingRequestStrategyToJSON(value['strategy']),
    };
}

